import { useI18n } from 'vue-i18n'

type DayOfWeek = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'

function isCurrentlyOpened(hours: Record<DayOfWeek, string>) {
    const i18n = useI18n()
    const timeZone = i18n.t('timezone')
    const dateStr = new Date().toLocaleString('sv-SE', { timeZone })
    const date = new Date(dateStr)
    const days: DayOfWeek[] = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
    const dayName = days[date.getDay()]
    const currentMinutes = date.getHours() * 60 + date.getMinutes()

    function parseTimeRange(range: string) {
        if (!range || !range.includes('-')) return null
        const [startStr, endStr] = range.split('-').map((s) => s.trim())
        const [startH, startM] = startStr.split(':').map(Number)
        const [endH, endM] = endStr.split(':').map(Number)
        return {
            start: startH * 60 + startM,
            end: endH * 60 + endM,
        }
    }

    const range = parseTimeRange(hours[dayName])

    return range && currentMinutes >= range.start && currentMinutes < range.end
}

export const getCustomerCareStatus = () => {
    const i18n = useI18n()

    const phone = i18n.tm<string, string, string, undefined, Record<DayOfWeek, string>>('customerCare.phoneOpeningHours')
    if (isCurrentlyOpened(phone)) {
        return 'phone'
    }

    const chat = i18n.tm<string, string, string, undefined, Record<DayOfWeek, string>>('customerCare.chatOpeningHours')
    if (isCurrentlyOpened(chat)) {
        return 'chat'
    }

    return 'closed'
}
